module.exports = __webpack_public_path__ + "static/media/icons-ic-dispositions-left-voicemail.9ef86d32.svg";